import React from 'react';

import { AppContextProvider } from '@contexts/AppContext';
import { AboutProps } from '@utils/aboutInterfaces';

import Address from './Address';
import BrandPartner from './BrandPartner';
import Career from './Careers';
import ContactUs from './ContactUs';
import LetterFromEditor from './LetterFromEditor';
import OurTeam from './OurTeam';
import Testimonial from './Testimonial';

const About = ({ canSendMessage, env, initialCurrentUser, isWebview, jobs, team }: AboutProps) => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <div className="relative mx-auto max-w-[1060px]">
        <div className="mb-24  px-16 sm:mb-48 sm:px-[27px] lg:mb-72">
          <div className="flex flex-col ">
            <h1 className="my-0 mb-16 text-center font-suisse-works text-headline-sm sm:text-headline-xl">
              About The Information
            </h1>
            <div className="flex justify-center">
              <span className="max-w-[512px] text-center font-suisse-neue text-body-md sm:text-body-lg">
                The Information is where you go to get the most important news about technology and
                business first.
              </span>
            </div>
          </div>
          <div className="my-32 flex w-full items-end border-0 border-b border-solid border-grayscale-gray sm:my-64 sm:items-center"></div>
          <LetterFromEditor env={env} />
          <div className="my-48 flex w-full items-end border-0 border-b-[5px] border-solid border-primary-magenta xs:mb-24 sm:mb-32 sm:mt-48 sm:items-center md:mt-80"></div>
          <Testimonial env={env} />
          <OurTeam team={team} canSendMessage={canSendMessage} />
          <BrandPartner />
          <Career env={env} jobs={jobs} />
          <div className="my-48 flex w-full items-end border-0 border-b border-solid border-grayscale-gray sm:my-80 sm:items-center"></div>
          <Address />
          <div className="my-48 flex w-full items-end border-0 border-b border-solid border-grayscale-gray sm:my-80 sm:items-center"></div>
          <ContactUs />
        </div>
      </div>
    </AppContextProvider>
  );
};

export default About;
